import React, { useEffect, useRef } from 'react';
import { Check } from 'lucide-react';

const TEINTES = ['#10B981', '#34D399', '#6EE7B7', '#378ADD', '#85B7EB', '#B5D4F4', '#FBBF24', '#F472B6'];

const TechChantierTermine = ({ nbEtapes = 7, onFini }) => {
  const scene = useRef(null);
  const anim = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => tirer(), 1250);
    const fin = setTimeout(() => { if (onFini) onFini(); }, 3800);
    return () => {
      clearTimeout(t);
      clearTimeout(fin);
      if (anim.current) cancelAnimationFrame(anim.current);
    };
  }, []);

  const tirer = () => {
    const s = scene.current;
    if (!s) return;
    const L = s.offsetWidth, H = s.offsetHeight;
    const parts = [];

    ['g', 'd'].forEach((cote) => {
      for (let i = 0; i < 38; i++) {
        const d = document.createElement('div');
        d.style.cssText = 'position:absolute;width:7px;height:11px;border-radius:2px;left:0;top:0;will-change:transform';
        d.style.background = TEINTES[i % TEINTES.length];
        s.appendChild(d);

        const v = 7 + Math.random() * 7;
        const a = (-12 - Math.random() * 74) * Math.PI / 180;
        parts.push({
          el: d,
          x: cote === 'g' ? -8 : L + 8,
          y: H * 0.88,
          vx: (cote === 'g' ? 1 : -1) * v * Math.cos(a),
          vy: v * Math.sin(a),
          rot: Math.random() * 360,
          vr: (Math.random() - 0.5) * 16,
        });
      }
    });

    const g = 0.22, frott = 0.992;
    let debut = null;

    const boucle = (ts) => {
      if (!debut) debut = ts;
      const ecoule = ts - debut;

      parts.forEach((p) => {
        p.vy += g;
        p.vx *= frott;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        const op = ecoule > 1400 ? Math.max(0, 1 - (ecoule - 1400) / 1100) : 1;
        p.el.style.opacity = op;
        p.el.style.transform = `translate(${p.x}px, ${p.y}px) rotate(${p.rot}deg)`;
      });

      if (ecoule < 2600) anim.current = requestAnimationFrame(boucle);
      else parts.forEach((p) => p.el.remove());
    };
    anim.current = requestAnimationFrame(boucle);
  };

  const jalons = [];
  for (let i = 0; i < 5; i++) {
    const dernier = i === 4;
    const taille = dernier ? 30 : 22;
    jalons.push(
      <div key={`p${i}`}
        style={{
          width: `${taille}px`, height: `${taille}px`, borderRadius: '50%', background: '#10B981',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          animation: dernier
            ? `cocheT .34s cubic-bezier(.3,1.5,.5,1) ${1.05}s both, glowT 1.4s ease-out 1.4s infinite`
            : `cocheT .34s cubic-bezier(.3,1.5,.5,1) ${0.05 + i * 0.25}s both`,
        }}>
        <Check size={dernier ? 17 : 13} color="#fff" strokeWidth={3} />
      </div>
    );
    if (i < 4) {
      jalons.push(
        <div key={`l${i}`} style={{ flex: 1, height: '2px', background: 'rgba(255,255,255,.1)', position: 'relative', margin: '0 3px' }}>
          <div style={{ position: 'absolute', inset: 0, width: 0, background: '#10B981', animation: `ligneT .2s linear ${0.15 + i * 0.25}s both` }} />
        </div>
      );
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 400, background: '#0B1F19', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <style>{`
        @keyframes cocheT { 0% { transform: scale(0) } 65% { transform: scale(1.25) } 100% { transform: scale(1) } }
        @keyframes ligneT { to { width: 100% } }
        @keyframes txtT { 0% { opacity: 0; transform: translateY(12px) } 100% { opacity: 1; transform: translateY(0) } }
        @keyframes glowT { 0%,100% { box-shadow: 0 0 0 0 rgba(16,185,129,.4) } 50% { box-shadow: 0 0 0 10px rgba(16,185,129,0) } }
      `}</style>

      <div ref={scene}
        style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '28px 20px', overflow: 'hidden' }}>

        <div style={{ display: 'flex', alignItems: 'center', width: '100%', maxWidth: '250px', marginBottom: '30px' }}>
          {jalons}
        </div>

        <div style={{ fontSize: '12px', color: 'rgba(255,255,255,.45)', letterSpacing: '.5px', marginBottom: '9px', animation: 'txtT .5s ease-out 1.3s both' }}>
          {nbEtapes} ÉTAPES SUR {nbEtapes}
        </div>
        <div style={{ fontSize: '23px', color: '#fff', marginBottom: '14px', animation: 'txtT .5s ease-out 1.45s both' }}>
          Installation terminée
        </div>
        <div style={{ fontSize: '14px', color: '#6EE7B7', animation: 'txtT .5s ease-out 1.65s both' }}>
          Beau travail
        </div>
      </div>
    </div>
  );
};

export default TechChantierTermine;
